import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeviceStore = defineStore('device', () => {
  const isIOS = ref(false);
  const isAndroid = ref(false);

  const detectDevice = () => {
    try {
      const ua = navigator.userAgent || navigator.vendor || window.opera;

      // iOS ve iPad OS cihazları için kontrol
      if (/iPhone|iPod/.test(ua) || 
         ((/iPad|Macintosh/.test(ua)) && navigator.maxTouchPoints > 1)) {
        isIOS.value = true;
      }

      // Android cihazlar için kontrol
      if (/android/i.test(ua)) {
        isAndroid.value = true;
      }
    } catch (error) {
      console.warn('Cihaz algılama hatası:', error);
      // Varsayılan değerler
      isIOS.value = false;
      isAndroid.value = false;
    }
  };

  return {
    isIOS,
    isAndroid,
    detectDevice
  };
});